<template>
  <div
    id="connectorScreen"
    class="page"
  >
    <div class="page-toolbar bg-white shadow-sm p-3">
      <h4 class="m-0">
        Connector Screen
      </h4>
      <b-button-toolbar key-nav>
        <b-button-group>
          <b-button
            id="addNewConnector"
            variant="secondary"
            size="sm"
            @click="onNewConnectorClick"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />
            Add New Connector
          </b-button>
        </b-button-group>
      </b-button-toolbar>
    </div>
    <content-spinner :show="loading" />
    <div
      v-if="!loading"
      class="content__grid"
    >
      <div
        v-for="(item, index) in allConnectors"
        :key="item.configurationId"
      >
        <connector-card-new
          v-if="item.connectorInstanceId"
          :item="item"
          :index="index"
          @on-edit-click="onEditClick"
          @on-delete-click="(item) => onDeleteClick(item, true)"
        />
        <connector-card
          v-else
          :item="item"
          :index="index"
          @on-edit-click="onEditClick"
          @on-delete-click="onDeleteClick"
        />
      </div>
    </div>
    <ConnectorModal />
    <EndpointModal />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ConnectorModal from './modals/ConnectorModal';
import ContentSpinner from '../../core/components/ContentSpinner';
import NoContent from '../../core/components/NoContent';
import EndpointModal from './modals/EndpointModal';
import ConnectorCard from './components/ConnectorCard';
import ConnectorCardNew from './components/ConnectorCardNew.vue';

const {mapState, mapActions} = createNamespacedHelpers('connectorScreen');
export default {
  name: 'ConnectorScreen',
  components: {
    ConnectorCard,
    ConnectorCardNew,
    EndpointModal,
    NoContent,
    ContentSpinner,
    ConnectorModal,
  },
  data() {
    return {
      salesforceConnectors: [],
    };
  },
  computed: {
    ...mapState([
      'connectors',
      'salesforceNewConnectors',
      'dynamoNewConnectors',
      'loading',
    ]),
    allConnectors() {
      const legacyConnectors = this.connectors;
      const newSalesforceConnectors = this.salesforceNewConnectors.map(c => ({...c, vendor: 'Salesforce'}));
      const newDynamoConnectors = this.dynamoNewConnectors.map(c => ({...c, vendor: 'Dynamo'}));
      return legacyConnectors.concat(newSalesforceConnectors).concat(newDynamoConnectors);
    },
  },
  methods: {
    ...mapActions([
      'getAllConnector',
      'getAllSalesforceNewConnector',
      'getAllDynamoNewConnector',
      'showConnectorModal',
      'deleteConnector',
      'deleteSalesForceNewConnector',
      'deleteDynamoNewConnector',
      'showEndpointModal',
      'deleteEndpoint',
    ]),
    onNewConnectorClick() {
      this.showConnectorModal(null);
    },
    onEditClick(item) {
      this.showConnectorModal(item);
    },
    async onDeleteClick(item, isNewSalesforce) {
      const configurationId = item.configurationId
        ? item.configurationId
        : item.connectorInstanceId;
      const confirm = await this.$confirm(
        'Deleting Connector...',
        'You are deleting connector. Are you sure you want to continue?',
      );
      if (confirm) {
        let success = false;
        let body = null;
        const isNewDynamo = item.connectorType === 'dynamo';
        if(isNewDynamo) {
          isNewSalesforce = false;
        }
        if (isNewSalesforce) {
          const response = await this.deleteSalesForceNewConnector(configurationId);
          success = response.success;
          body = response.body;
        }else if(isNewDynamo) {
          const response = await this.deleteDynamoNewConnector(configurationId);
          success = response.success;
          body = response.body;
        } else {
          const response = await this.deleteConnector(configurationId);
          success = response.success;
          body = response.body;
        }
        if (success) {
          this.$toasted.success('Connector deleted successfully', {
            duration: TOASTER_DURATION,
          });
        } else {
          this.$toasted.error(body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
  },
  async mounted() {
    await this.getAllConnector();
    await this.getAllSalesforceNewConnector();
    await this.getAllDynamoNewConnector();
  },
};
</script>

<style lang="scss" scoped>
.content__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  overflow-y: auto;
  padding: 20px;
}

.header-buttons {
  cursor: pointer;
}
</style>